import { ORDERS_ACCESS } from '@/helpers/permissionsConstant'

export default [
  {
    title: 'Exports',
    icon: 'DownloadIcon',
    gate: ORDERS_ACCESS,
    children: [
      { title: 'Pending Orders', route: 'exports-pending', gate: ORDERS_ACCESS },
      { title: 'Processing Orders', route: 'exports-processing', gate: ORDERS_ACCESS },
      { title: 'Packing Orders', route: 'exports-packing', gate: ORDERS_ACCESS },
      { title: 'Shipping Orders', route: 'exports-shipping', gate: ORDERS_ACCESS },
      { title: 'On The Way', route: 'exports-on_the_way', gate: ORDERS_ACCESS },
      { title: 'In Review', route: 'exports-in_review', gate: ORDERS_ACCESS },
      { title: 'Rejected Orders', route: 'exports-rejected', gate: ORDERS_ACCESS },
      { title: 'Returned Orders', route: 'exports-returned', gate: ORDERS_ACCESS },
      { title: 'Canceled Orders', route: 'exports-canceled', gate: ORDERS_ACCESS },
      { title: 'Delivered Orders', route: 'exports-delivered', gate: ORDERS_ACCESS },
      { title: 'Pending 1 Orders', route: 'exports-pending-1', gate: ORDERS_ACCESS },
      { title: 'Pending 2 Orders', route: 'exports-pending-2', gate: ORDERS_ACCESS },
    ],
  },
]